/*
Created request Reducer to save questionnaire evaluation data
 */
export const questionnaireEvaluationSaveRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isSaveSuccess: false, hasEvaluated: action.payload.hasEvaluated });
};
//# sourceMappingURL=questionnaireEvaluationSaveRequestReducer.js.map